import React, { useCallback, useEffect } from "react";
import Header from "../sections/Header";
import Footer from "../sections/Footer";
import "../style/style.css";
import PortfolioInfo from "../sections/PortfolioInfo";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { PATHS } from "../utils";
import useKontentServiceApi from "../services/useKontentServiceApi";
import useCategories from "../services/useCategories";

const useQuery = () => {
  return new URLSearchParams(useLocation().search);
};

const PortfolioInfoPage = () => {
  const navigate = useNavigate();
  const query = useQuery();
  const { slug } = useParams();
  
  // const [code, setCode] = useState<string>("");
  const validateURLParams = useCallback(
    (str: string) => {
      try {
        return atob(str);
      } catch (err) {
        navigate(PATHS.notFoundPage);
      }
    },
    [navigate]
  );

  // Handle both query parameter and slug-based routing
  let id: string | null = null;
  let decodedStr: string | null = null;
  let isSlugLookup = false;

  if (slug) {
    // New slug-based routing
    decodedStr = slug;
    isSlugLookup = true;
  } else {
    // Legacy query parameter routing
    id = query.get("id") as string;
    decodedStr = validateURLParams(id) as string;
    isSlugLookup = false;
  }

  const { data, errorCode, loading } = useKontentServiceApi(decodedStr, isSlugLookup);

  const { categories } = useCategories("industry_tags");


  useEffect(() => {
    if (decodedStr && errorCode === 100) {
      navigate(PATHS.notFoundPage);
    }
  }, [decodedStr, errorCode, navigate]);

  return (
    <>
      <Header loading={loading} />
      <PortfolioInfo data={data} categories={categories} />
      <Footer />
    </>
  );
};

export default PortfolioInfoPage;
